export { default } from './Backdrop';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Backdrop/index.js
// module id = 400
// module chunks = 2